export default {
    bind(el, binding) {
      //找到对应的ul元素节点
      const SELECTDOM = el.querySelector(
        '.el-select-dropdown .el-select-dropdown__wrap'
      )
      // 为对应的ul绑定滚动条滚动事件
      SELECTDOM.addEventListener('scroll', function () {
        const condition =
          this.scrollHeight - this.scrollTop <= this.clientHeight
        // 判断滚动到底部
        if (condition) {
        //   console.log(condition) //为true就是到底了
          // 检查binding.value是否为函数，如果是才调用
          if (typeof binding.value === 'function') {
            binding.value()
          } else {
            console.warn('v-loadmore指令的值必须是一个函数')
          }
        }
      })
    }
  }